import { LinkText } from '@/components/atoms'
import CustomDataTable from '@/components/organisms/CustomDataTable/CustomDataTable'
import { getCellDataMappedCols } from '@/helpers/dataTableCellDataMapper'
import { downloadCSVFiles, getDateWithTimeString } from '@/helpers/shadcn/utils'
import { Constants, DISABLE_HEADERS } from '@/utils/constants/commonConstants'
import { useSalesTargets } from '@/hooks/useSalesTargets'
import { getSalesTargetsReporteDownload } from '@/services/salesTargets'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ROUTES } from '@/utils/constants/routesConstants'
// eslint-disable-next-line
export const cellDataMapperObj = navigate => ({
  salesTargetName: {
    cellData: ({ row: { original } = {} }) => (
      <LinkText
        text={original?.salesTargetName || '—'}
        id={original?.salesTargetName + ' ' + (original?.id || original?.uuid)}
        handleClick={() => navigate(`${ROUTES.SALES_TARGET_DETAIL.replace(':id', original?.id || original?.uuid)}?status=${original?.status}`)}
      />
    ),
    linkHandler: (row) => navigate(`${ROUTES.SALES_TARGET_DETAIL.replace(':id', row?.id || row?.uuid)}?status=${row?.status}`),
    linkLabel: (row) => row.salesTargetName || '—',
  },
  numEligibleStores: {
    cellData: ({ row: { original } = {} }) => <div>{original?.numEligibleStores ?? '—'}</div>,
  },
  percentageAchievedTarget: {
    cellData: ({ row: { original } = {} }) => <div>{original?.percentageAchievedTarget ?? '—'}</div>,
  },
  pointsAwarded: {
    cellData: ({ row: { original } = {} }) => <div>{original?.pointsAwarded ?? '—'}</div>,
  },
  createdAt: {
    cellData: ({ row: { original } = {} }) => <div>{original?.createdAt ?? original?.startDate ?? '—'}</div>,
  },
  endDate: {
    cellData: ({ row: { original } = {} }) => <div>{original?.endDate ?? '—'}</div>,
  },
  status: {
    cellData: ({ row: { original } = {} }) => <div className={original?.status === 'Error' ? 'status_error' : ''}>{original?.status ?? '—'}</div>,
    render: (row) => <div className={row.status === 'Error' ? 'status_error' : ''}>{row.status}</div>,
  },
  reportUrl: {
    cellData: ({ row: { original } = {} }) => {
      if (original.status === Constants.Draft) {
        return <div className="text-gray-500">Sales Target Report</div>;
      }
      return (
        <LinkText
          text={"Sales Target Report"}
          id={original?.id}
          handleClick={() => onDownloadForSalesTargetsReport(original.id, original.status)}
        />
      );
    },
    downloadHandler: (row) => onDownloadForSalesTargetsReport(row.id, row.status),
    downloadLabel: () => 'Sales Target Report',
    render: (row, column) => {
      if (row.status === Constants.Draft) {
        return <div className="text-gray-500 px-2 py-1">Sales Target Report</div>;
      }
      return (
        <LinkText
          text={column.downloadLabel()}
          id={row.id}
          handleClick={() => column.downloadHandler(row)}
        />
      );
    },
  },
  lastUpdated: {
    cellData: ({ row: { original } = {} }) => <div>{original?.lastUpdated ?? original?.lastUpdatedDate ?? '—'}</div>,
  },
  updatedBy: {
    cellData: ({ row: { original } = {} }) => <div>{original?.updatedBy ?? '—'}</div>,
  },
});

const onDownloadForSalesTargetsReport = async (selectedIds, status) => {
  if (status === Constants.Draft) {
    return;
  } else {
    const data = await getSalesTargetsReporteDownload(`salesTargetId=${selectedIds}`);
    const fileName = `SalesTarget_Report${getDateWithTimeString()}`
    downloadCSVFiles(data, fileName)
  }
}

export const SalesTargetList = () => {
  const navigate = useNavigate()

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [rowSelected, setRowSelected] = useState([])
  const [isSelectAll, setIsSelectAll] = useState(false)
  const {
    salesTargetsData,
    salesTargetsColConfigData,
    pageIndex,
    setPageIndex,
    setSortingObj,
    sortingObj,
    setSearchArry,
    onDownloadBtnClick,
    isLoading,
    handleResetAll
  } = useSalesTargets()

  const cellDataMappedCols = getCellDataMappedCols(cellDataMapperObj(navigate), salesTargetsColConfigData)

  const onDownloadClick = async (selectedRows) => {
    // selectedRows is empty array when select all is active (passed from CustomDataTable)
    // Otherwise it contains the selected row objects
    const ids = selectedRows?.length > 0 
      ? selectedRows.map(item => item?.id || item?.uuid)
      : [];
    onDownloadBtnClick(ids)
  }

  return (
    <div className="salesTargetsDataTable">
      <CustomDataTable
        columns={cellDataMappedCols}
        records={salesTargetsData?.data || []}
        isLoading={isLoading}
        pageSize={10}
        totalRecords={salesTargetsData?.totalRecords || 0}
        setPageIndex={setPageIndex}
        handleSorting={setSortingObj}
        setSearchArry={setSearchArry}
        onResetAll={handleResetAll}
        onRowSelect={(selectedRecords, isAll) => {
          setRowSelected(selectedRecords)
          setIsSelectAll(isAll)
        }}
        onDownload={onDownloadClick}
        showDownload={true}
        isSelectAll={isSelectAll}
        pageIndex={pageIndex}
        initialSortConfig={sortingObj}
        disabledHeaders={DISABLE_HEADERS.SALES_TARGET_HEADERS}
      />
      {salesTargetsData?.totalRecords > 0 && (
        <div className="txtRightAlign position-absolute" >
          {salesTargetsData?.totalRecords} total items
        </div>
      )}
    </div>
  )
}
